import { useMutation } from '@apollo/client'
import { UPDATE_ORDER_CODE, GET_ORDER_BY_ID } from '../OrderQueries'
import { EditableTextField } from '@/components/shared/EditableTextField'
import { toast } from 'sonner'

interface EditableOrderCodeProps {
  orderId: string
  currentValue: string | null
}

export function EditableOrderCode({
  orderId,
  currentValue,
}: EditableOrderCodeProps) {
  const [updateOrderCode] = useMutation(UPDATE_ORDER_CODE, {
    refetchQueries: [
      {
        query: GET_ORDER_BY_ID,
        variables: { id: orderId },
      },
    ],
    onCompleted: () => {
      toast.success('Order code updated successfully')
    },
    onError: error => {
      toast.error(`Failed to update order code: ${error.message}`)
    },
  })

  const handleSave = async (newValue: string | null) => {
    await updateOrderCode({
      variables: {
        where: { id: orderId },
        order_code: newValue,
      },
    })
  }

  return <EditableTextField value={currentValue} onSave={handleSave} />
}
